import { render, staticRenderFns } from "./mapacontrolavaliacao.vue?vue&type=template&id=1a25ac42&"
import script from "./mapacontrolavaliacao.vue?vue&type=script&lang=js&"
export * from "./mapacontrolavaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports